/**
 * Returns background color class based on first character of a name
 * Used for avatar / assignee badges
 */
export function getAvatarBgColor(name?: string): string {
  if (!name?.trim()) return 'bg-secondary';

  const firstChar = name.trim().charAt(0).toUpperCase();

  const colorMap: Record<string, string> = {
    A: 'bg-primary',
    B: 'bg-success',
    C: 'bg-warning',
    D: 'bg-info',
    E: 'bg-danger',
    F: 'bg-dark',
    G: 'bg-primary-subtle',
    H: 'bg-success',
    I: 'bg-warning-subtle',
    J: 'bg-info',
    K: 'bg-danger-subtle',
    L: 'bg-dark-subtle',
    M: 'bg-primary',
    N: 'bg-danger',
    O: 'bg-warning',
    P: 'bg-success',
    Q: 'bg-danger',
    R: 'bg-gray-600',
    S: 'bg-danger',
    T: 'bg-success-subtle',
    U: 'bg-warning-subtle',
    V: 'bg-info-subtle',
    W: 'bg-danger-subtle',
    X: 'bg-dark-subtle',
    Y: 'bg-primary',
    Z: 'bg-success',
  };

  return colorMap[firstChar] || 'bg-secondary';
}
